import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MESSAGE_TYPES, ReceiveMessageType } from 'src/@types/message';
import useWebViewCommunication from 'src/hooks/useWebViewCommunication';
import { useStores } from 'src/models';
import { PATH_PAGE } from 'src/routes/paths';
import { settingsApi } from 'src/services';

type NavigateTarget = 'home' | 'calendar' | 'myPage' | 'notification';

const NAVIGATE_TARGET_MAP: Record<NavigateTarget, string> = {
  home: PATH_PAGE.home,
  calendar: PATH_PAGE.calendar.root,
  myPage: PATH_PAGE.myPage.root,
  notification: PATH_PAGE.notification,
  // W2~ GLP-1 도메인 추가 예정:
  //   record:  PATH_PAGE.record.root,
  //   report:  PATH_PAGE.report.root,
  //   chat:    PATH_PAGE.chat.root,
};

function AppMessageListener() {
  const { authStore } = useStores();
  const navigate = useNavigate();
  // handle message from RN
  const handleRNMessage = useCallback(
    (message: ReceiveMessageType) => {
      // AUTH_VERIFICATION 응답은 다른 핸들러에서 처리
      if ('resultCode' in message) {
        return;
      }

      switch (message.type) {
        case MESSAGE_TYPES.DEVICE_TOKEN: {
          const token = message.payload.deviceToken;
          settingsApi.saveDeviceToken(token);
          break;
        }
        case MESSAGE_TYPES.NAVIGATE: {
          const target = message.payload.target;
          const routePath = NAVIGATE_TARGET_MAP[target];
          if (routePath) {
            navigate(routePath);
          }
          break;
        }
      }
    },
    [navigate],
  );

  const { sendMessage } = useWebViewCommunication(handleRNMessage);

  useEffect(() => {
    if (authStore.user) {
      if (!authStore.isSaved) {
        sendMessage({ type: MESSAGE_TYPES.DEVICE_TOKEN });
        authStore.setProp('isSaved', true);
      }
    }
  }, [authStore, sendMessage]);

  return null;
}

export default AppMessageListener;
